import React from 'react';
import HeroSection from '../components/HeroSection';
import LogoWall from '../components/LogoWall';
import PainPoints from '../components/PainPoints';
import SolutionsGrid from '../components/SolutionsGrid';
import EDIProcessAnimation from '../components/EDIProcessAnimation';
import QualityMetrics from '../components/QualityMetrics';
import CompareSection from '../components/CompareSection';
import CustomersSection from '../components/CustomersSection';
import ValueProps from '../components/ValueProps';
import TestimonialsCarousel from '../components/TestimonialsCarousel';
import CTASection from '../components/CTASection';
import useDocumentTitle from '../hooks/useDocumentTitle';

/**
 * Home - the marketing landing page.
 *
 * Flow (Cleo-style arc, 2026-06):
 *   Branding (hero + speed)
 *   → Social proof (customer logo wall)
 *   → Pain (what's broken with legacy EDI)
 *   → Solution (solutions grid - Managed EDI leads)
 *   → How it works (EDI process animation)
 *   → Reliability (quality metrics)
 *   → Differentiation (compare vs. the alternatives)
 *   → Industry breadth + compliance (customers section)
 *   → Why (value props)
 *   → Testimonials → CTA
 *
 * Section backgrounds intentionally alternate canvas/soft for visual rhythm.
 *
 * WelcomeSection was dropped from the home flow (2026-06) - its brand-statement
 * copy was redundant with the hero, and the page was getting long. The
 * component still exists; re-add it here if we want it back. Leadership and
 * Case Studies live on their dedicated routes.
 */
const Home = () => {
  // Home gets just "iConnect" in the tab - empty suffix suppresses the
  // default " | iConnect" the hook would otherwise append.
  useDocumentTitle(
    {
      title: 'iConnect',
      description:
        'iConnect: a Value Added Network connecting 39,000+ trading partners since 2000. Simple, complete, cost-effective EDI solutions with 24/7 support and no long-term contracts.',
    },
    ''
  );

  return (
    <>
      <HeroSection />
      <LogoWall />
      <PainPoints />
      <SolutionsGrid />
      <EDIProcessAnimation />
      <QualityMetrics />
      <CompareSection />
      <CustomersSection />
      <ValueProps />
      <TestimonialsCarousel />
      <CTASection />
    </>
  );
};

export default Home;
